export const getAgentActionsUrl = (workspaceId: string, agentID: string) => `
/business/workspaces/${workspaceId}/agents/${agentID}/agent_actions`;

export const getAgentActionUrl = (workspaceId: string, agentID: string, actionId: string) => `
/business/workspaces/${workspaceId}/agents/${agentID}/agent_actions/${actionId}`;
